export const GAME_IDS = ['fruit-merge','water-sort','color-blocks','tower','snake','neon-coil','minesweeper','solitaire','block-fill','color-connect','ball-run','pool','animal-stack','flappy-bird','globle','blockcraft','maze-muncher','corn-clicker','slipline','quadfall','fivefold','claimline','crossy-road','quad-clash'] as const;
export type GameId = typeof GAME_IDS[number];
export interface Settings { sound: boolean; reducedMotion: boolean; colorBlind: boolean; autoNextEpisode: boolean }
export interface GameContext {
  readonly id: GameId;
  readonly settings: Readonly<Settings>;
  readonly highScore: number;
  setScore(score: number): void;
  /** Optional game-specific rankings, using the shared account-backed service. */
  submitRecord?(key:string,score:number):void;
  openRankings?(key:string):void;
  setPaused?(paused:boolean):void;
  openAppMenu?():void;
  setLevel(level: string | number): void;
  setStatus(message: string): void;
  announce(message: string): void;
  save(data: unknown): void;
  sound(kind?: 'tap' | 'success' | 'lose'): void;
}
export interface GameInstance {
  openMenu?():void;
  dismissMenu?():boolean;
  pause(): void;
  resume(): void;
  restart(): void | boolean;
  serialize(): unknown;
  restore(data: unknown): void;
  dispose(): void;
}
export interface GameModule {
  readonly id: GameId;
  readonly title: string;
  readonly cover: string;
  readonly rules: string;
  mount(container: HTMLElement, context: GameContext): GameInstance | Promise<GameInstance>;
}
